@use "../../../styles/variables.scss" as *;

.loaderContainer {
  display: flex;
  height: calc(100dvh - 60px);
  justify-content: center;
  align-items: center;
}

.loader {
  display: block;

  &::after {
    border-color: $almost-black $almost-black $almost-black transparent;
  }
}
